<template>
  <div class="flex flex-col flex-1 px-4 py-4 overflow-y-auto">
    <MessageBubble
      v-for="msg in messages"
      :key="msg.id"
      :messageId="msg.id"
      :text="msg.text || msg.content"
      :isUser="msg.sender === 'user'"
      :isLoading="msg.isLoading"
      :isError="msg.isError"
      :cta="msg.cta"
      :sources="msg.sources"
      :tokens="msg.tokens"
      :isStreaming="msg.isStreaming"
      :timestamp="msg.timestamp"
      :cacheStats="msg.cacheStats"
      :products="msg.products"
      :user="user"
      :shareTokenMode="shareTokenMode"
      :attachments="msg.attachments"
      @suggestion="$emit('suggestion', $event)"
      @sendMessage="$emit('sendMessage', $event)"
      @editMessage="$emit('editMessage', $event)"
    />
  </div>
</template>

<script setup>
import MessageBubble from "./MessageBubble.vue";

const props = defineProps({
  messages: {
    type: Array,
    required: true,
  },
  user: {
    type: Object,
    default: null,
  },
  shareTokenMode: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["suggestion", "sendMessage", "editMessage"]);
</script>
